import { render } from "./Register.vue?vue&type=template&id=3c11cbe8&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "@/assets/scss/_register.scss?vue&type=style&index=0&id=3c11cbe8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c11cbe8"]])

export default __exports__